module.exports = __webpack_public_path__ + "img/zyh.32bf800b.jpg";